<style scoped>
.flex-container {
  display: flex;
  align-items: stretch;  /* Make the flex items stretch to fill the container */
}

/* Define your flex items */
.flex-item {
  flex: 50%;  /* Allow the flex items to grow and shrink as needed */
  display: flex;
  justify-content: center;
  align-items: center;
  padding:10px;
  border:1px solid white;
}

/* Change layout for smaller screens */
@media (max-width: 800px) {
  .flex-container {
    flex-direction: column;  /* Stack the flex items vertically */
  }
}
</style>
<template>
    <div>
        <div>
            <div style="width:100%;height:100%;background:#ddd;">
                {{ title }} 
                <div v-if="xAccount !== null" class="flex-container">
                    <div class="flex-item">
                        <span class="glyphicon">User:</span>
                        <span class="glyphicon">{{ xAccount.surname }} {{ xAccount.givenName }}</span>
                    </div>
                    <div class="flex-item"> 
                        Since: {{ xAccount.createDate }}
                        Domain: <span> [{{ xAccount.domainRootId }}]</span>
                    </div>
                </div>
            </div>

            <div>
                <div class="col-xs-12 col-sm-4 col-md-3">
                    <div style="position: relative; height:150px;line-height:150px;border:1px solid gray;text-align:center;" class="pbcss-store-logo">
                        <router-link :to="{ path: '/Shoplist' }" class="btn btn-default" style="position: absolute; bottom: 0; left: 0; right: 0; margin: auto;">
                            {{ lang.common.shops }}
                        </router-link>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-3">
                    <div style="position: relative; height:150px;line-height:150px;border:1px solid gray;text-align:center;" class="pbcss-account-logo">
                        <a href="/Account" class="btn btn-default" style="position: absolute; bottom: 0; left: 0; right: 0; margin: auto;">
                            {{ lang.navi.account }}
                        </a>
                    </div>
                </div>
                <!-- <div class="col-xs-12 col-sm-4 col-md-3">
                    <div style="position: relative; height:150px;line-height:150px;border:1px solid gray;text-align:center;" class="pbcss-location-logo">
                        <router-link :to="{ path: '/Location', query: { shopUserId: xUserId } }" class="btn btn-default" style="position: absolute; bottom: 0; left: 0; right: 0; margin: auto;">
                            {{ lang.common.savedLocations }}
                        </router-link>
                    </div>
                </div> -->
            </div>
        </div>

    </div>
</template>

<script>
import shopInfo from './shopInfo.vue';
import shopsList from './shopsList.vue';
import pagedReply from './pagedReply.vue';
import postEditor from './postEditor.vue';
import apis from '../api/extApi.js';

export default {
    components: {
        shopInfo: shopInfo,
        shopsList: shopsList,
        pagedReply: pagedReply,
        postEditor: postEditor
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        xStore: function () {
            return this.$store;
        },
        xShowingLogin: function () {
            return this.$store.getters.showingLogin;
        },
        xAccount: function () {
            return this.$store.getters.account;
        },
        xUserId: function () {
            if(this.xAccount) {
                return this.xAccount.userId;
            }
            return null;
        }
    },
    data: function () {
        return {
            apiClient: apis.api,
            uiClient: apis.ui,
            title: "",
            boardId: "",
            shopInfo: null,
            isEditingPost: false,
            postClient: null,
            loginMsg: null,
            loginInfo: { name: null, password: null }
        };
    },
    methods: {
        goTo: function (boardId) {
            this.boardId = boardId;
        }
    },
    created: function () {

    },
    mounted: function () {

    }
}
</script>
